import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLiberapayComponent } from './simple-icons-liberapay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLiberapayComponent ],
    exports:      [ SimpleIconsLiberapayComponent ],
    bootstrap:    []
})
export class SimpleIconsLiberapayModule {}
